import { useMemo, useState } from "react";
import SectionHeader from "./SectionHeader";
import { glossaryTerms } from "@/pages/home/data/glossary";

export default function Glossary() {
  const [query, setQuery] = useState("");

  const result = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return glossaryTerms;
    return glossaryTerms.filter((t) =>
      `${t.term}${t.tag}${t.meaning}${t.example}`.toLowerCase().includes(q),
    );
  }, [query]);

  return (
    <section id="glossary" className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <SectionHeader
            eyebrow="粉圈词典"
            title="吃瓜前先认字：粉圈黑话速查"
            description="塌房、回踩、站姐、超话……把这套黑话认全，你才能从评论区里读出真正的立场。支持关键词实时筛选。"
          />
          <label className="relative block w-full max-w-xs shrink-0">
            <span className="sr-only">搜索词典</span>
            <i
              className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"
              aria-hidden="true"
            ></i>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索词条，如：回踩"
              className="w-full rounded-md border border-background-300 bg-background-50 py-2.5 pl-9 pr-3 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            />
          </label>
        </div>

        <p className="mt-6 text-xs text-foreground-500">
          共 {glossaryTerms.length} 个词条 · 当前显示 {result.length} 个
        </p>

        <div className="mt-4 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {result.map((t, i) => (
            <article
              key={t.term}
              className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
            >
              <div className="flex items-start justify-between gap-3">
                <h3 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
                  <span className="text-sm font-normal text-foreground-300">{String(i + 1).padStart(2, "0")}</span>
                  {t.term}
                </h3>
                <span className="whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800">
                  {t.tag}
                </span>
              </div>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{t.meaning}</p>
              <p className="mt-4 rounded-lg bg-background-100 px-3 py-2.5 text-[13px] leading-relaxed text-foreground-600">
                <span className="mr-1 font-medium text-secondary-700">例：</span>
                {t.example}
              </p>
            </article>
          ))}
        </div>

        {result.length === 0 && (
          <div className="mt-6 rounded-xl border border-dashed border-background-300 bg-background-50 px-6 py-14 text-center">
            <i className="ri-file-search-line text-4xl text-foreground-300" aria-hidden="true"></i>
            <p className="mt-3 text-sm text-foreground-600">没有找到与「{query}」相关的词条，换个词试试。</p>
          </div>
        )}
      </div>
    </section>
  );
}